// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2a1c4148","239":"e2c988e4","453":"1e2a1810","849":"1f474b31"}[chunkId] + ".chunk.js";
};